/* M2a/M2c · the notation key, in one place.
 *
 * Reached two ways and identical from both: a first-encounter notice inside
 * the drill (which is where the question actually occurs to someone), and the
 * Help section in Settings, which is the permanent route back for anyone who
 * dismissed it. Six rows and no prose — this is a legend, not a lesson, and
 * the figurines (M1a) have already removed the part that needed teaching.
 */
import { C, PRIMARY } from "../theme.js";
import { Sheet } from "../Sheet.jsx";

export default function NotationKey({ translate, onClose, mobile }) {
  const rows = ["pieces", "pawn", "capture", "castle", "number"];
  return (
    <Sheet title={translate("firstTime.notation.title")} onClose={onClose} mobile={mobile}>
      <div data-testid="notation-key-sheet" style={{ color: C.sub, fontSize: 13, lineHeight: 1.6, marginBottom: 10 }}>
        {translate("firstTime.notation.lead")}
      </div>
      {rows.map((row) => (
        <div
          key={row}
          style={{ borderTop: `1px solid ${C.faint}`, color: C.ink, fontSize: 13, lineHeight: 1.55, padding: "9px 0" }}
        >
          {translate(`firstTime.notation.${row}`)}
        </div>
      ))}
      <button
        onClick={onClose}
        style={{ ...PRIMARY, marginBottom: 4, marginTop: 14, width: "100%" }}
      >
        {translate("firstTime.notation.action")}
      </button>
    </Sheet>
  );
}
